import { render, staticRenderFns } from "./QuizeABCDSelectForm.vue?vue&type=template&id=4861798c&"
import script from "./QuizeABCDSelectForm.vue?vue&type=script&lang=ts&"
export * from "./QuizeABCDSelectForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports